import axios from "@/api/axiosAuthRequired.js"
const instaproBaseUrl = `${process.env.INSTAPRO_API_URL}api/v1/`

export const getBookingAvailabilities = async (instaproToken, { from, to }) => {
  try {
    const url = `${instaproBaseUrl}coach/booking/availabilities`
    const params = {
      from,
      to,
    }
    const config = {
      params,
      headers: {
        Authorization: "Bearer " + instaproToken,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response
  }
}

export const getTimeSlotsByDate = async (instaproToken, date) => {
  try {
    const url = `${instaproBaseUrl}coach/booking/timeslots/in-game`
    const params = {
      date,
    }
    const config = {
      params,
      headers: {
        Authorization: "Bearer " + instaproToken,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response
  }
}

export const updateCoachBookingAvailabilities = async (instaproToken, body) => {
  try {
    const url = `${instaproBaseUrl}coach/booking/availabilities`
    const config = {
      headers: {
        Authorization: "Bearer " + instaproToken,
      },
    }
    const res = await axios.put(url, body, config)
    return res.data
  } catch (error) {
    return error.response
  }
}

export const getCoachBookedSessions = async (instaproToken, from, to) => {
  try {
    const url = `${instaproBaseUrl}coach/booking`
    const params = {
      from,
      to,
    }
    const config = {
      params,
      headers: {
        Authorization: "Bearer " + instaproToken,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    return error.response
  }
}



// WEBPACK FOOTER //
// ./src/api/user/coaching/schedule.js